const state = {
	// Регистрация. Получить код
	registrationState: {},

	// Проверяем код подтверждения
	confirmationCodeState: {},

	//  Увеличить количество попыток (attempts)
	increaseAttemptsState: { count: 0 },

	// Номер телефона
	phoneNumberState: { phone: "", actionType: "" },
};

export default state;
